export default class YPContactBooking {
  static #icons = Object.freeze({
    organization: 'organization',
    person: 'bullet',
    contactlink: 'link'
  });

  constructor(bookingJSON) {
    const { contact, role, id } = bookingJSON;
    this.id = id;
    this.role = role;
    let { name } = contact;
    this.contactLinkName = null;
    this.contactInfo = [];
    if (!name && contact.person) name = contact.person.name;
    this.name = name;
    if (contact.organization)
      this.contactLinkName = `${contact.jobtitle} ${contact.organization.name}`;
    // eslint-disable-next-line no-underscore-dangle
    this.contactReferenceType = bookingJSON.contact._type;
    this.contactReferenceID = bookingJSON.contact.id;
  }

  getIcon() {
    return (
      this.contactReferenceType && YPContactBooking.#icons[this.contactReferenceType]
    );
  }

  setContactReference(contactReferences) {
    const { contactLinks, contacts } = contactReferences;
    this.contactReference = (this.isForContactLink() ? contactLinks : contacts).find(
      (ref) => ref.id === this.contactReferenceID
    );
    if (this.contactReference)
      this.contactInfo = this.contactReference.contactinfo.map((info) => ({
        contactType: info.type,
        contactValue: info.value
      }));
  }

  isForContactLink() {
    return (
      this.contactReferenceType !== null &&
      this.contactReferenceType.toUpperCase() === 'CONTACTLINK'
    );
  }
}
